/** Simple Web Audio API tone generator for signal-change alerts.
 * No audio files — synthesized on the fly. */

const STORAGE_KEY = "forex.sound";

let _ctx = null;
function getCtx() {
  if (typeof window === "undefined") return null;
  if (_ctx) return _ctx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
  } catch { return null; }
  return _ctx;
}

function beep(ctx, freq, duration, gain = 0.15, type = "sine", delay = 0) {
  const t = ctx.currentTime + delay;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t);
  g.gain.setValueAtTime(0, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t + duration);
  osc.connect(g).connect(ctx.destination);
  osc.start(t);
  osc.stop(t + duration + 0.05);
}

/** Ascending triad → BUY */
function playBuy(ctx) {
  beep(ctx, 523.25, 0.12, 0.18, "sine", 0);      // C5
  beep(ctx, 659.25, 0.12, 0.18, "sine", 0.11);   // E5
  beep(ctx, 783.99, 0.22, 0.20, "sine", 0.22);   // G5
}

/** Descending pair → SELL */
function playSell(ctx) {
  beep(ctx, 587.33, 0.14, 0.18, "sine", 0);      // D5
  beep(ctx, 440.00, 0.26, 0.20, "sine", 0.13);   // A4
}

/** Soft ping → HOLD */
function playHold(ctx) {
  beep(ctx, 660, 0.16, 0.14, "triangle", 0);
}

export function playSignalSound(signal) {
  if (!isSoundEnabled()) return;
  const ctx = getCtx();
  if (!ctx) return;
  // Resume if suspended by autoplay policy
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  if (signal === "buy") playBuy(ctx);
  else if (signal === "sell") playSell(ctx);
  else playHold(ctx);
}

export function isSoundEnabled() {
  try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
}

export function setSoundEnabled(on) {
  try { localStorage.setItem(STORAGE_KEY, on ? "1" : "0"); } catch {}
  // "warm up" the audio context on user gesture so subsequent tones play immediately
  if (on) {
    const ctx = getCtx();
    if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
  }
}
